import client from './client';

export interface ChatInputLimits {
  maxAttachmentsPerMessage: number;
  maxMessageLengthChars: number;
}

export async function fetchChatInputLimits(): Promise<ChatInputLimits> {
  const response = await client.get<ChatInputLimits>('/api/v1/conversations/limits');
  return response.data;
}
